import { endOfDay, parse } from 'date-fns'

import type { SortProps } from '@components/shared/Table/types'
import type { PreviewManagementFiltersFormProps } from '../../PreviewManagementFilters/form/types'
import type { PreviewHistoryExtraFiltersFormProps } from '../components/HistoryFilters/types'
import type { PreviewStatusHistoryRequestProps } from '../../../../../services/api/previewManagement/types'

interface BuildPreviewHistoryPayloadProps {
  referenceDate: string
  branchCode?: string | null
  baseFilters: PreviewManagementFiltersFormProps | null
  extraFilters: PreviewHistoryExtraFiltersFormProps | null
  sort?: SortProps | null
  currentPage: number
  itemsPerPage: number
}

const parseBrDate = (value: string) => parse(value, 'dd/MM/yyyy', new Date())

// "all" é a opção "Todos" vinda do endpoint de filtros — não vai no payload
const toMultiFilter = (values?: string[] | null) => {
  const filtered = values?.filter((value) => value !== 'all')
  return filtered && filtered.length > 0 ? filtered : undefined
}

const isSelected = (value?: string) => !!value && value !== 'all'

export const buildPreviewHistoryPayload = ({
  referenceDate,
  branchCode,
  baseFilters,
  extraFilters,
  sort,
  currentPage,
  itemsPerPage
}: BuildPreviewHistoryPayloadProps): PreviewStatusHistoryRequestProps => ({
  referenceDate,
  branchCodeFilter: branchCode ? [branchCode] : undefined,
  businessUnitFilter: toMultiFilter(baseFilters?.businessUnit ? [baseFilters.businessUnit] : undefined),
  boardOfDirectorsFilter: toMultiFilter(baseFilters?.directorate),
  portfolioFilter: toMultiFilter(baseFilters?.portfolio),
  economicGroupFilter: toMultiFilter(baseFilters?.economicGroup),
  productFilter: toMultiFilter(baseFilters?.segment),
  serviceTypeFilter: toMultiFilter(baseFilters?.serviceType),
  goGceNamesFilter: toMultiFilter([...(baseFilters?.goName ?? []), ...(baseFilters?.gceName ?? [])]),
  weekNumber: isSelected(extraFilters?.weekNumber) ? Number(extraFilters!.weekNumber) : undefined,
  // ponytail: o mesmo code vai nos dois campos (conta e Gross Profit) — confirmar com o back se combinam com OU
  accountStatusCodeNew: isSelected(extraFilters?.status) ? extraFilters!.status : undefined,
  grossProfitStatusCodeNew: isSelected(extraFilters?.status) ? extraFilters!.status : undefined,
  isAutomaticSend: isSelected(extraFilters?.isAutoSend) ? extraFilters!.isAutoSend === 'true' : undefined,
  responsibleUserId: isSelected(extraFilters?.responsibleUserId) ? Number(extraFilters!.responsibleUserId) : undefined,
  userProfile: isSelected(extraFilters?.userProfile) ? extraFilters!.userProfile : undefined,
  createdAtFrom: extraFilters?.startDate ? parseBrDate(extraFilters.startDate).toISOString() : undefined,
  createdAtTo: extraFilters?.endDate ? endOfDay(parseBrDate(extraFilters.endDate)).toISOString() : undefined,
  sortBy: sort?.sortBy,
  sortType: sort?.sortType,
  currentPage,
  itemsPerPage
})
